'use client'
const TagChip = ({ children }) => {
  return (
    <div
      style={{
        backgroundColor: '#D1E9FF',
        fontWeight: '500',
        padding: '8px 12px 5px',
        borderRadius: '16px',
        marginRight: '8px',
        marginBottom: '8px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '32px'
      }}
      className="tag-chip badge"
    >
      <p style={{ margin: 0, color: 'var(--alrajhi-black)', fontSize: '14px' }}>{children}</p>
    </div>
  )
}

export default TagChip
